export default __webpack_public_path__ + "static/media/orbital.035952ff.jpg";